/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2UnlockIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2UnlockIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2UnlockIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2UnlockIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-1NfkD7': alignSelf,'--mt-2-1NfkD7': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1NfkD7': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1NfkD7': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1NfkD7': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1NfkD7': opacity,'--w-10-1NfkD7': typeof width === 'number' ? `${width}px` : width,'--h-11-1NfkD7': typeof height === 'number' ? `${height}px` : height,'--f-12-1NfkD7': fill,'--a-7-1NfkD7': isAnimated ? animation : "none",'--sd-8-1NfkD7': isAnimated ? strokeDashoffset : 0,'--sd-9-1NfkD7': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2UnlockIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M16.286 10.286A2.286 2.286 0 0014 12.57v1.143h4.571v-1.143a2.286 2.286 0 00-2.285-2.285zm-4.572 2.285v1.143c-.947 0-1.714.768-1.714 1.715v6.857c0 .947.768 1.714 1.714 1.714h9.143c.947 0 1.714-.767 1.714-1.714v-6.857c0-.947-.767-1.715-1.714-1.715v-1.143a4.571 4.571 0 00-9.143 0zm4.572 7.715a1.429 1.429 0 100-2.857 1.429 1.429 0 000 2.857z"
 style={{'--f-12-1NfkD7': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}